(function () {
  // The footer newsletter form (sections/community-footer.liquid) submits natively — a real page
  // reload — rather than being AJAX-ified. The reload lands back on this same section with
  // form.posted_successfully?/form.errors already reflected in the section's own data-state/
  // data-footer-newsletter-check attributes (see that file). This form still goes through
  // Shopify's own hCaptcha protection (no data-nocaptcha opt-out), which can pause on its own
  // challenge before the real submit/reload happens, so the listener below shows the button's
  // spinner right away and leaves it up through that whole wait — it does NOT call
  // preventDefault, so the native submit (and hCaptcha's own handling of it) proceeds untouched.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-footer-newsletter-form]');
    if (!form) return;
    var submitButton = form.querySelector('[data-footer-subscribe]');
    if (!submitButton || submitButton.disabled) return;
    submitButton.disabled = true;
    var spinner = submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  });

  // This script's only other job is to fade the success message back into the empty form a few
  // seconds later on that reload, instead of leaving a permanent confirmation up.
  var NEWSLETTER_REVERT_MS = 3200;

  function revertPostedSuccessfully() {
    var wrap = document.querySelector('[data-footer-newsletter][data-state="success"]');
    if (!wrap) return;
    var check = wrap.querySelector('[data-footer-newsletter-check]');
    var emailInput = wrap.querySelector('[data-footer-email]');
    var consentInput = wrap.querySelector('[data-footer-consent]');

    setTimeout(function () {
      wrap.setAttribute('data-state', 'form');
      if (check) check.setAttribute('data-state', 'out');
      if (emailInput) emailInput.value = '';
      if (consentInput) consentInput.checked = false;
    }, NEWSLETTER_REVERT_MS);
  }

  revertPostedSuccessfully();
})();
